import Vue from 'vue'
import {merge,isObject,isArray,isString,get,has,keys,map,forOwn,isEqual,every,cloneDeep,omitBy,mapValues,toPairs} from 'lodash'
import jsonPointer from '@/utils/jsonPointer'
import {columnsByProperties} from "./tableLayout";

const loadedHyperSchemas = {};

export const checkOnLoadHyperSchema = (hyperSchema) => {
  if (isObject(hyperSchema)) {
    if (!hyperSchema.$id) return Promise.reject(new Error("Hyperschema must have $id"));
    if (!loadedHyperSchemas[hyperSchema.$id]) loadedHyperSchemas[hyperSchema.$id] = hyperSchema;
    return Promise.resolve(hyperSchema);
  }
  if (isString(hyperSchema) && hyperSchema.startsWith("/")) {
    let loadedHyperSchema = loadedHyperSchemas[hyperSchema];
    if (loadedHyperSchema) return Promise.resolve(loadedHyperSchema);
    else return Vue.axios.get(hyperSchema).then(responce => {
      loadedHyperSchema = responce.data;
      loadedHyperSchemas[hyperSchema] = loadedHyperSchema;
      return loadedHyperSchema
    })
  }
  return Promise.reject(new Error("Unknow type hyperschema"))
};


export const getHyperSchemasByIDs = (ids) => {
  return Promise.all([].concat(ids).map(id => checkOnLoadHyperSchema(id)))
};

export const searchEntities = (hyperSchemaOrUrl, search) => {
  return checkOnLoadHyperSchema(hyperSchemaOrUrl).then(hyperSchema => {
    const link = search.grouping != undefined ? hyperSchema.links.groupedSearch : hyperSchema.links.search;
    if (link)
      return Vue.axios({
        method: link.method,
        url: (hyperSchema.base + (link.href ? link.href : "")),
        params: isString(search) ? {search} : search
      }).then(responce => responce.data);
    else return Promise.reject(new Error("Unsupport operation for this Entities"))
  });

};

export const removeEntities = (hyperSchemaOrUrl, idEntities) => {
  return checkOnLoadHyperSchema(hyperSchemaOrUrl).then(hyperSchema => {
    if ([].concat(idEntities).length == 0) return Promise.resolve();
    const link = hyperSchema.links.deleteIds;
    if (link)
      return Vue.axios({
        method: link.method,
        // url: (hyperSchema.base+(link.href?link.href:"")),
        url: hyperSchema.base,//TODO вернуть обратно
        params: {"ids": [].concat(idEntities).join(",").replace("#", "")}//For OrientDB
      }).then(responce => responce.data);
    else return Promise.reject(new Error("Unsupport operation for this Entities"))
  });

};

export const findOneEntity = (hyperSchemaOrUrl, idEntity) => {
  return checkOnLoadHyperSchema(hyperSchemaOrUrl).then(hyperSchema => {
    const link = hyperSchema.links.findOne;
    if (link) {
      link.href = link.href.replace("{id}", isString(idEntity) ? idEntity.replace("#", "") : idEntity);//For OrientDB
      return Vue.axios({
        method: link.method,
        url: (hyperSchema.base + link.href)
      }).then(responce => responce.data)
    } else return Promise.reject(new Error("Unsupport operation for this Entities"))
  });

};

export const updateEntity = (hyperSchemaOrUrl, entity) => {
  return checkOnLoadHyperSchema(hyperSchemaOrUrl).then(hyperSchema => {
    const link = hyperSchema.links.update;
    if (link) {
      return Vue.axios({
        method: link.method,
        url: (hyperSchema.base + link.href),
        data: entity
      }).then(responce => responce.data)
    } else return Promise.reject(new Error("Unsupport operation for this Entities"))
  });
};

export const handleEventEntity = (action, entityId) => {
  const url = action.href.replace("{id}", isString(entityId) ? entityId.replace("#", "") : entityId);
  return Vue.axios({
    method: action.method,
    url: url,
  }).then(responce => responce.data)
};

export const propertiesToArrayRecursive = (properties, propNameParent = '', titleParent = '') => {
  return toPairs(properties).map(pair => {
    const propName = propNameParent ? (propNameParent + "." + pair[0]) : pair[0];
    const title = titleParent ? (titleParent + "-" + pair[1].title || pair[0]) : pair[1].title || pair[0];
    if (pair[1].properties) return propertiesToArray(pair[1].properties, propName, title);
    return {propName, prop: pair[1], title}
  })
};

export const getAllPossiblePropertiesExcludeSpecialPromise = (schema) => {
  return checkOnLoadHyperSchema(schema).then(h => getAllPossiblePropertiesExcludeSpecial(h));
};

export const solveRefIfNeed = (prop, globalSchema) => {
  if (prop.$ref) {
    const title = prop.title;//Сохраняем исходный title
    prop = jsonPointer.get(globalSchema, prop.$ref);
    if (title) prop.title = title;
  }
  return prop;
};

export const removeNullAndSpecial = (properties) => omitBy(properties, prop => prop.type == "null" || prop.format == "special");

export const getVisibleProperties = (properties, globalSchema) => {

  const visibleProperties = {};

  keys(properties).forEach(propName => {
    const prop = solveRefIfNeed(properties[propName], globalSchema);

    //также фильтруем дочерние свойства
    if (prop.properties) prop.properties = removeNullAndSpecial(prop.properties);

    visibleProperties[propName] = prop;
  });

  return removeNullAndSpecial(visibleProperties);
};

export const getAllPossiblePropertiesExcludeSpecial = (schema) => {
  const visibleProperties = getVisibleProperties(schema.properties, schema);

  (schema.allOf || [])
    .forEach(allOfElement => (allOfElement.oneOf || [])
      .filter(oneOfElement => oneOfElement.properties)
      .forEach(oneOfElement => merge(visibleProperties, getVisibleProperties(oneOfElement.properties, schema)))
    );

  return {properties: visibleProperties}

};

export const generateTableColumnsBySchemaPromise = (schema, model, includeNested) => {
  return checkOnLoadHyperSchema(schema).then(h => generateTableColumnsBySchema(h, model, includeNested));
};

//Start refactoring----------------------------------------------------------------


export const inputControl = (path, prop, modelPath) => {
  return {
    "component": "input-control",
    "params": {
      "props": {
        "options": {},
        "property": prop,
        "value": "{vue.$lodash.get(vue." + modelPath + ",'" + path + "')}"
      },
      "on": {
        "input": "{function(e){Vue.$nestedSet(vue." + modelPath + ", '" + path + "', e)}}"
      },
    }
  }
};

export const checkBoxControl = (path, prop, modelPath, options = {}) => {
  return {
    "component": "checkbox-control",
    "params": {
      "props": {
        "options": options,
        "property": prop,
        "value": "{vue.$lodash.get(vue." + modelPath + ",'" + path + "')}"
      },
      "on": {
        "input": "{function(e){Vue.$nestedSet(vue." + modelPath + ", '" + path + "', e)}}"
      },
    }
  }
};

export const textAreaControl = (path, prop, modelPath) => {
  return {
    "component": "text-area-control",
    "params": {
      "props": {
        "options": {},
        "property": prop,
        "value": "{vue.$lodash.get(vue." + modelPath + ",'" + path + "')}"
      },
      "on": {
        "input": "{function(e){Vue.$nestedSet(vue." + modelPath + ", '" + path + "', e)}}"
      },
    }
  }
};

export const simpleView = (modelPath, path) => {
  return {
    "component": "simple-value-view",
    "params": {
      "props": {
        "value": "{vue.$lodash.get(vue." + modelPath + ",'" + path + "')}",
        "dateTimeFormat": "",
        "titleProp": "label"
      }
    }
  }
};

export const httpControl = (httpSchemas, path, modelPath, isMulti, hideSearch = false) => {
  return {
    "component": "dropdown-http-control",
    "params": {
      "props": {
        "url": isArray(httpSchemas) ? httpSchemas[0].url : httpSchemas,//TODO переделать под каскад
        "value": "{vue.$lodash.get(vue." + modelPath + ",'" + path + "')" + (isMulti ? "||[]" : "||null") + "}",
        hideSearch
      },
      "on": {
        "input": "{function(e){Vue.$nestedSet(vue." + modelPath + ", '" + path + "', e)}}"
      },
    },
    "children": []
  }
};

//Table section----------------------------------------------------------------------------------
export const tableColumn = (title, path, layout, sortable) => {
  return {
    "title": title,
    "path": path,
    "sortable": sortable,
    "layout$": layout
  }
};

export const tableColumnCheckBoxControl = (path, prop) => {
  return tableColumn(prop.title || '', path, checkBoxControl(path, prop, "data.rowData", {hideLabel: true}), prop.sortable)
};

export const tableColumnSimpleView = (title, path) => {
  return tableColumn(title || '', path, simpleView("data.rowData", path))
};

export const tableColumnHttpControl = (title, path, httpSchemas, isMulti, hideSearch) => {
  return tableColumn(title || '', path, httpControl(httpSchemas, path, "data.rowData", isMulti, hideSearch))
};

export const tableColumnInputControl = (path, prop) => {
  return tableColumn(prop.title || '', path, inputControl(path, prop, "data.rowData"), prop.sortable)
};

// export const tableColumnControlByProp = (path, prop) => {
//   if (prop.type == "string") return tableColumnInputControl(path, prop)
//   if (prop.type == "integer" || prop.type == "number") return tableColumnInputControl(path, prop);
//   if (prop.httpSchemas) return tableColumnHttpControl(prop.title, path, prop.httpSchemas)
//
// }


//end Table section----------------------------------------------------------------------------------

export const tabsComponentLayoutBySchemaPromise = (schema, modelPath) => {
  return checkOnLoadHyperSchema(schema).then(schema => tabsComponentLayoutByProperties(schema.properties, modelPath))
};

export const tabsComponentLayoutByProperties = (properties, modelPath) => {
  const tabTitles = [];
  const tabComponents = [];
  forOwn(properties, (prop, propName) => {
    if (prop.type == "string" && prop.maxLength) {
      tabComponents.push(merge(textAreaControl(propName, prop, modelPath), {params: {style: "width:100%"}}));
      tabTitles.push(prop.title || "");
    }
  });
  return {
    "component": "tab-layout",
    "params": {
      "props": {
        // "initIndexShowChildren":initIndexShowChildren,
        "tabNames": tabTitles,
        //"labelText":allOf.title+":",
        //"isRadio":true,
        // "tabComp":{
        //   "component":'div',
        //   "params":{
        //     "props":{
        //       "style":"display:inline-block"
        //     }
        //   }
        // },
        // "tabNameComp":{
        //   "component":'div',
        //   "params":{
        //     "props":{
        //       "class":"ui radio checkbox",
        //       "style":"padding-left:10px"
        //     }
        //   }
        // },
        // "labelComp":{
        //   "component":'h5',
        //   "params":{
        //     "props":{
        //       "style":{
        //         "font-weight":"bold",
        //         "color":"black",
        //         "display":"inline-block"
        //       }
        //
        //     }
        //
        //   }
        // },

      },
    },
    "children": tabComponents
  }
};

//-------------------end refactoring--------------------------------------------


export const tipicalLabelColumn = (path, title, compProps = {}, sort = false) => {
  return {
    "visible": true,
    "sortable": sort,
    "path": path,
    "layout": {
      "component": "simple-value-view",
      "params": {
        "props": merge({
          "value": "{Vue.$lodash.get(vue.data.rowData,'" + path + "')}",
          "dateTimeFormat": "",
          "titleProp": "label"
        }, compProps)
      }
    },
    "title": title
  }
};

export const tipicalMinMaxDateTimePickerColumn = (pathMin, pathMax, title) => {
  return {
    "visible": true,
    "sortable": false,
    "layout": {
      "component": "el-date-picker",
      "params": {
        "props": {
          "value": "{[vue.$lodash.get(vue.data.rowData,'" + pathMin + "'),vue.$lodash.get(vue.data.rowData,'" + pathMax + "')]}",//может не работать реактивность
          "type": "datetimerange",
        },
        "on": {
          "input": "{function(e){Vue.$nestedSet(vue.data.rowData, '" + pathMin + "', +e[0]);Vue.$nestedSet(vue.data.rowData, '" + pathMax + "', +e[1])}}"
        }
      }
    },
    "title": title
  }

};

export const tipicalDropdownHTTPColumn = (path, title, url, columns, hardParams = {}) => {
  return {
    "visible": true,
    "sortable": false,
    "path": path,
    "layout": {
      "component": "dropdown-http-control",
      "params": {
        "props": {
          "value": "{Vue.$lodash.get(vue.data.rowData,'" + path + "')||null}",//null чтобы корректно определять multiValue в dropdown element
          "url": url,
          "columns": columns,
          "hardParams": hardParams,
        },
        "on": {
          "input": "{function(e){Vue.$nestedSet(vue.data.rowData, '" + path + "', e)}}"
        }
      }
    },
    "title": title
  }
};

export const tipicalListColumn = (title, prop, path) => {
  return {
    "visible": true,
    "sortable": false,
    "title": title,
    "path": path,
    "layout": {
      "component": "array-list-view",
      "params": {
        "props": {
          "prop": prop,
          "value": "{Vue.$lodash.get(vue.data.rowData,'" + path + "')||[]}",
        }
      },
      "on": {
        "input": "{function(e){Vue.$nestedSet(vue.data.rowData, '" + path + "', e)}}"
      }
    }
  }

};


export const tipicalArrayColumn = (path, title, compProps = {}, optionSlotLayout) => {
  return {
    "visible": true,
    "sortable": false,
    "path": path,
    "layout": {
      "component": "semui-dropdown",
      "params": {
        "props": merge({
          //"value": "{vue.$lodash.get(vue.data.rowData,'"+path+"')}",
          "value": "{[].concat(vue.$lodash.get(vue.data.rowData,'" + path + "'))}",//TODO потом убрать
          //"options": "{vue.$lodash.get(vue.data.rowData,'"+path+"')}",
          "options": "{[].concat(vue.$lodash.get(vue.data.rowData,'" + path + "'))}",//TODO потом убрать
          "multipleSelect": true,
          "enableSearch": false,
          "disableChange": true,
          "inputIconClass": ""
        }, compProps)
      },
      "scopedSlots": optionSlotLayout ? {"options": {"layout": optionSlotLayout}} : {}
    },
    "title": title
  }
};


export const generateTableColumnsBySchema = (schema, model, includeNested = true) => {//TODO убрать параметр model и подкооректировтаь все вызовы

  const tipicalFsmButtonsColumn = (statePropPath, transitionRules) => {
    return {
      "visible": true,
      "layout": {
        "component": "buttons-control",
        "data": {
          "transitionRules": transitionRules
        },
        "params": {
          "props": {
            "actions": "{vue.data.transitionRules[Vue.$lodash.get(vue.data.rowData,'" + statePropPath + "')]}"
          },
          "on": {
            "actionClick": "{function(action){vue.$jsonSchemeUtils.handleEventEntity(action,vue.data.rowData.id)}}"
          }
        },
      },
      "title": ""
    }
  };


  const tipicalArrayColumnSchema = (propPath, title, prop) => {
    return tipicalArrayColumn(
      propPath,
      prop.unit ? (title || propPath) + ", " + prop.unit.title : (title || propPath),
    )

  };

  const tipicalLabelColumnSchema = (propPath, title, prop, sort = true) => {
    return tipicalLabelColumn(
      propPath,
      prop.unit ? (title || propPath) + ", " + prop.unit.title : (title || propPath),
      {
        "dateTimeFormat": prop.format == "date-time" ? "DD.MM.YYYY hh:mm:ss" : prop.format == "date" ? "DD.MM.YYYY" : "",
        "value": "{Vue.$lodash.get(vue.data.rowData,'" + propPath + "')" + (prop.unit ? "*" + prop.unit.coeffForUI : '') + "}",
      },
      sort
    )

  };

  const getColumnComponent = (propName, prop, keyParent = "", titleParent = "") => {
    let p = prop;
    if (prop.$ref) {
      p = jsonPointer.get(schema, p.$ref);
      if (!p.title) p.title = prop.title;
    }


    if (p.type == "array") {
      let itemProp = isArray(p.items)?p.items[0]:p.items;
      //return tipicalArrayColumnSchema(keyParent+propName,titleParent+prop.title,prop)
      itemProp = itemProp.$ref ? jsonPointer.get(schema, itemProp.$ref) : itemProp;
      return tipicalListColumn(p.title, itemProp, keyParent + propName)
    }
    if (p.type == "string" && p.maxLength) return undefined;
    return tipicalLabelColumnSchema(keyParent + propName, titleParent + p.title, p)
  };

  const generateColumns = (properties, keyParent = "", titleParent = "") => {
    let columns = [];
    forOwn(properties, (prop, propName) => {
      if (prop.properties && includeNested) {
        //columns=columns.concat(generateColumns(prop.properties,propName+".",prop.title+"-"))
        columns = columns.concat(generateColumns(prop.properties, propName + ".", ""))
      } else {
        const columnComponent = getColumnComponent(propName, prop, keyParent, titleParent);
        if (columnComponent) columns.push(columnComponent)
      }

    });
    return columns;
  };

  let columns = generateColumns(omitBy(getAllPossiblePropertiesExcludeSpecial(schema).properties,prop=>prop.columnHide));

  if (schema.links.fsm) {
    let statePropPath = undefined;
    forOwn(schema.properties, (v, k) => {
      if (v.type == 'string' && v.enum && every(v.enum, el => schema.links.fsm[el])) statePropPath = k
    });
    if (statePropPath) columns.push(tipicalFsmButtonsColumn(statePropPath, schema.links.fsm))
  }

  //Проверяем, чтобы label шел первый
  const labelColumn = columns.filter(col => col.path == "label") || [];
  columns = labelColumn.concat(columns.filter(col => col.path != "label"));
  //---------------------------------


  return columns;


};


export const tipicalDropDownHttpControl = (propName, prop, model, isMulti, hideSearch = false) => {
  return {
    "component": "dropdown-http-control",
    "params": {
      "props": {
        "url": isArray(prop.httpSchemas) ? prop.httpSchemas[0].url : prop.httpSchemas,//TODO переделать под каскад
        "value": "{vue.$lodash.get(vue.model,'" + propName + "')" + (isMulti ? "||[]" : "||null") + "}",//подключаем lodash для nested property
        hideSearch
      },
      "on": {
        "input": (e) => Vue.$nestedSet(model, propName, e)
      },
    },
    "children": []
  }
};

export const tipicalControlWithLabel = (label, control, withValidateErrorsShowMessage = false, clickCloseCallback) => {
  const closeIcon = {
    "component": "i",
    "params": {
      "class": "icon remove",
      "style": "opacity: 0.5; color:grey",
      "on": {
        "click": clickCloseCallback
      }
    }
  };
  const validateErrorDirective = [
    {
      "name": 'show-validate-errors',
      "value": "{vue.$lodash.get(vue.$children[0],'errors')}",
    }
  ];
  return {
    "component": "div",
    "params": {
      "class": "ui form  sixteen wide column",
      "directives": withValidateErrorsShowMessage ? validateErrorDirective : []
    },
    "children": [
      {
        "component": "div",
        "params": {"class": "field"},
        "children": label ? [
          {"component": "label", "children": [clickCloseCallback ? closeIcon : '', label]},

        ] : []
      },
      control
    ]
  }
};

export const generateJsonLayoutBySchemePromise = (hyperSchema, model, options) => {
  return checkOnLoadHyperSchema(hyperSchema).then(h => generateJsonLayoutByScheme(h, model, options));
};

export const generateJsonLayoutByScheme = function (hyperSchema, model, options = {}) {

  const tipicalSingleTemplateParams = (k, p, model) => {
    return {
      "params": {
        // "class": 'sixteen wide column',
        "props": {
          "options": {},
          "property": p,
          "value": "{vue.$lodash.get(vue.model,'" + k + "')}"//подключаем lodash для nested property
          // "value": get(model,k) - нет реактивности при таком варианте
        },
        "on": {
          //"input": (e) => Vue.$nestedSet(model, k, e)
          "input": "{function(e){vue.$nestedSet(vue.model,'" + k + "', e)}}"
        },
        // "directives": [
        //   {
        //     "name": 'show-validate-errors',
        //     "value": "{vue.$lodash.get(vue.$children[0],'errors')}",
        //   }
        // ],
      }
    }
  };
  const tipicalMinMaxTemplateParams = (kMin, pMin, kMax, pMax, model) => {
    return {
      "params": {
        // "class":'sixteen wide column',
        "props": {
          "options": {},
          "propertyMin": pMin,
          "propertyMax": pMax,
          "valueMin": "{vue.$lodash.get(vue.model,'" + kMin + "')}",
          "valueMax": "{vue.$lodash.get(vue.model,'" + kMax + "')}"
        },
        "on": {
          "input": (e) => {
            Vue.$nestedSet(model, kMin, e[0]);
            Vue.$nestedSet(model, kMax, e[1])
          }
        },
        // "directives": [
        //   {
        //     "name": 'show-validate-errors',
        //     "value": "{vue.$lodash.get(vue.$children[0],'errors')}",
        //   }
        // ],
      }
    }
  };
  const generateForMinTipicalMinMaxTemplateParams = (properties, kMin, pMin, model) => {
    const maxPropName = pMin.maximum.$data.substring("1/".length);
    const nestedPropNameAsArray = kMin.split(".");
    nestedPropNameAsArray[nestedPropNameAsArray.length - 1] = maxPropName;
    const nestedMaxPropName = nestedPropNameAsArray.join(".");
    return tipicalMinMaxTemplateParams(kMin, pMin, nestedMaxPropName, properties[maxPropName], model)
  };

  const globalHyperSchema = hyperSchema;

  const getComponent = function (propName, prop, properties, clickCloseCallback, isItemArray) {
    let p = prop;

    if (p.hideInForm) return;

    if (options.calendar && options.calendar.includes(propName)) return;

    if (p.$ref) {
      p = jsonPointer.get(globalHyperSchema, p.$ref);
      if (!p.title) p.title = prop.title;
    }
    if (p.httpSchemas) return tipicalControlWithLabel(p.title, tipicalDropDownHttpControl(propName, p, model, isItemArray, options.hideSearch), false, clickCloseCallback);

    if (p.type == "string" && propName.toLowerCase().indexOf("geojson") != -1) {
      return {
        "component": "geojson-control",
        "params": {
          "style": {
            "height": "400px",
            "width": "100%"
          },
          "props": {
            "property": p,
            "value": "{vue.$lodash.get(vue.model,'" + propName + "')}"//подключаем lodash для nested property
          },
          "on": {
            "input": (e) => Vue.$nestedSet(model, propName, e)
          },
        },
        "children": []
      }
    }

    if (prop.type == "string" && prop.maxLength) return tipicalControlWithLabel(p.title, merge({"component": "text-area-control"}, tipicalSingleTemplateParams(propName, p, model)), true, clickCloseCallback);

    if (p.type == "string" && p.enum) return tipicalControlWithLabel(p.title, merge({"component": "select-control"}, tipicalSingleTemplateParams(propName, p, model)), true, clickCloseCallback);
    if (p.type == "string") return tipicalControlWithLabel(p.title, merge({"component": "input-control"}, tipicalSingleTemplateParams(propName, p, model)), true, clickCloseCallback);


    if (p.type == "integer" && (p.format == "date-time" || p.format == "date")) {
      if (isObject(p.maximum)) {//Значит relative-pointer. Если указано свойство maximum, значит это проперти min
        return {
          "component": "div",
          "params": {"class": "sixteen wide column"},
          "children": [tipicalControlWithLabel(p.title, null, true, clickCloseCallback), merge({"component": "el-date-time-picker-minmax-control"}, generateForMinTipicalMinMaxTemplateParams(properties, propName, p, model))]
        }
      } else if (isObject(p.minimum)) return undefined;
      //else return merge({ "component":"el-date-time-picker-control"},tipicalSingleTemplateParams(propName,p,model))
      else return {
          "component": "div",
          "params": {"class": "sixteen wide column"},
          "children": [tipicalControlWithLabel(p.title, null, true, clickCloseCallback), merge({"component": "el-date-time-picker-control"}, tipicalSingleTemplateParams(propName, p, model))]
        }
    }

    if (p.type == "integer" || p.type == "number") {
      if (isObject(p.maximum)) {//Значит relative-pointer. Если указано свойство maximum, значит это проперти min
        return tipicalControlWithLabel(p.title, merge({"component": "min-max-input-control"}, generateForMinTipicalMinMaxTemplateParams(properties, propName, p, model)), true, clickCloseCallback)
      } else if (isObject(p.minimum)) return undefined;
      else return tipicalControlWithLabel(p.title, merge({"component": "input-control"}, tipicalSingleTemplateParams(propName, p, model)), true, clickCloseCallback)
    }
    if (p.type == "null") return;


    if (p.type == "boolean") return merge({"component": "checkbox-control"}, tipicalSingleTemplateParams(propName, p, model));//TODO привести к tipicalControlWithLabel

    if (p.type == "array") {
      let itemProp = isArray(p.items)?p.items[0]:p.items;//TODO расширить для многих объектов

      if (itemProp.$ref) itemProp = jsonPointer.get(globalHyperSchema, itemProp.$ref);

      if (!itemProp.title) itemProp.title = p.title;

      if (itemProp.type == "object" && !itemProp.httpSchemas) {

        //const columns = map(itemProp.properties, (childProp, childPropName) => tableColumnControlByProp(childPropName, childProp.$ref ? jsonPointer.get(globalHyperSchema, childProp.$ref) : childProp))

        const columns = columnsByProperties(omitBy(itemProp.properties,prop=>prop.format=="special"),{forEditable:true,hyperSchema: globalHyperSchema});

        return tipicalControlWithLabel(p.title, {
          "component": "control-table",
          "params": {
            "props": {
              "rows": "{vue.model." + propName + "||[]}",
              "columns$": columns,
              "enableBottomRow": true,
              "enableLastColumn": true
            },
            "on": {
              "clickedAddRowButton": "{function(){vue.$pushOrCreateAndPush(vue.model,'" + propName + "',{})}}",
              "clickedDelRowButton": "{function(rowIndex,row){vue.model." + propName + ".splice(rowIndex, 1);}}"
            }
          }
        }, true, clickCloseCallback)
      }

      return getComponent(propName, itemProp, undefined, clickCloseCallback, true)


    }

    if (p.type == "object" && p.patternProperties) {

      const fields = keys(p.properties).map(propNameChild => {
        return {
          propName: propName + "." + propNameChild,
          prop: p.properties[propNameChild],
          label: p.properties[propNameChild].title
        }
      });
      //в поле fields перед удалением  вызываем Vue.$nestedSet(vue.model,e.propName,null), чтобы сработала реактивность при удалении
      return tipicalControlWithLabel(p.title, {
        "component": "dynamic-field-control",
        "data": {
          "getComponent": getComponent,
          "initFields": fields,
          "fields": "{vue.data.initFields.map(function(e,index){e.layout=vue.data.getComponent(e.propName,e.prop,null,function(f){vue.data.selectedFields.splice(vue.data.selectedFields.indexOf(e), 1);Vue.$nestedSet(vue.model,e.propName,null);vue.$deletePropertyPath(vue.model,e.propName)});return e})}",
          "selectedFields": "{vue.data.fields.filter(function(f){return vue.$lodash.has(vue.model,f.propName)})}",
        },
        "params": {
          "class": "ui grid",
          "props": {
            "model": "{vue.model}",
            "fields": "{vue.data.fields}",
            "selectedFields": "{vue.data.selectedFields}"
          },
          "on": {
            "input": "{function(e){vue.data.selectedFields.push(e); Vue.$nestedSet(vue.model,e.propName,e.prop&&e.prop.type=='array'?[]:null)}}"
          }
        },
        "children": []
      })
    }

    if (p.type == "object") {
      let children = keys(p.properties)
        .filter(childPropName => p.properties[childPropName]["format"] != "special")
        .map(childPropName => getComponent(((propName ? propName + "." : "") + childPropName), p.properties[childPropName], p.properties));

      children = children.concat((p.allOf || []).map(allOf => {
        const defModel = {};//сохраняем заполненные значени при переключении
        //-------------------------------------
        let initIndexShowChildren = 0;
        for (var i = 0; i < allOf.oneOf.length; i++) {
          if ((allOf.oneOf[i].required || []).every(requiredPropName => model[requiredPropName] != undefined)) {
            initIndexShowChildren = i;
            break;
          }
        }
        //-------------------------------------
        return {
          "component": "tab-layout",
          "params": {
            "class": 'sixteen wide column',
            "props": {
              "initIndexShowChildren": initIndexShowChildren,
              "tabNames": allOf.oneOf.map(e => e.title),
              "labelText": allOf.title + ":",
              "isRadio": true,
              "tabComp": {
                "component": 'div',
                "params": {
                  "props": {
                    "style": "display:inline-block"
                  }
                }
              },
              "tabNameComp": {
                "component": 'div',
                "params": {
                  "props": {
                    "class": "ui radio checkbox",
                    "style": "padding-left:10px"
                  }
                }
              },
              "labelComp": {
                "component": 'h5',
                "params": {
                  "props": {
                    "style": {
                      "font-weight": "bold",
                      "color": "black",
                      "display": "inline-block"
                    }

                  }

                }
              },

            },
            "on": {
              "jsonLayoutChangeIndexShowChildren": function (index) {
                const props = allOf.oneOf[index].properties;
                keys(props).filter(propName => props[propName].type == "null").forEach(propName => {
                  if (model[propName]) {
                    defModel[propName] = model[propName];
                    Vue.set(model, propName, null)
                  }
                });
                keys(props).filter(propName => props[propName].type != "null").forEach(propName => {
                  if (!model[propName] && defModel[propName]) model[propName] = defModel[propName]
                })
              }
            }
          },
          "children": allOf.oneOf.map(p => {
            return {
              "component": "div",
              "params": {
                "class": "ui grid",
                "style": {"margin-top": 0, "margin-bottom": 0,}
              },
              "children": getComponent(null, p).reduce((prev, current) => current ? prev.concat(current) : prev, [])
            }
          })
        }
      }));
      return children;
    }
  };

  const children = getComponent(null, hyperSchema).reduce((prev, current) => current ? prev.concat(current) : prev, []);//нормализуем массив и удаляем undefined

  if (options.calendar) {
    children.push({
      "component": "vue-work-week-calendar",
      "params": {
        "style": "height: 600px",
        "props": {
          "items": "{vue.model}",
          "weekTitles": [
            {
              title: 'Понедельник',
              key: options.calendar[0]
            },
            {
              title: 'Вторник',
              key: options.calendar[1]
            },
            {
              title: 'Среда',
              key: options.calendar[2]
            },
            {
              title: 'Четверг',
              key: options.calendar[3]
            },
            {
              title: 'Пятница',
              key: options.calendar[4]
            },
            {
              title: 'Суббота',
              key: options.calendar[5]
            },
            {
              title: 'Воскресенье',
              key: options.calendar[6]
            }]
        }
      },
      "children": []
    })
  }

  return {
    "component": "div",
    "params": {"class": 'ui grid'},
    "children": children
  }
};
